@if (!ynLlwytho) {
  <div class="llwythwr-system-placeholder"></div>
}

@if (ynLlwytho) {
  <mat-progress-bar class="llwythwr-system" color="accent" mode="indeterminate"></mat-progress-bar>
}